// extracted by mini-css-extract-plugin
export default {"page":"Home_page__L-yCy","pageWide":"Home_pageWide__60AQy","content":"Home_content__PvQTM","controllerArea":"Home_controllerArea__+VAwK"};